import { assignInput, BaseModel } from '../base.model';

export class ProspectConversionDetailsModel extends BaseModel {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ProspectID = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SSN = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Company;

  constructor(o = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
  }
}
